import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { api } from "@/lib/api";
import { useSeo } from "@/lib/seo";
import { AttivazioneForm } from "@/components/AttivazioneForm";

export default function Attivazione() {
  const { pkgId } = useParams();
  const [pkg, setPkg] = useState(undefined);
  useSeo("Richiesta di attivazione", "Modulo di richiesta attivazione del servizio di fatturazione elettronica.", `/attivazione/${pkgId}`);
  useEffect(() => {
    api.get("/public/packages").then((r) => setPkg(r.data.find((p) => p.id === pkgId) || null)).catch(() => setPkg(null));
  }, [pkgId]);
  return (
    <div className="min-h-screen bg-slate-100 px-4 py-10 sm:px-8">
      <article data-testid="attivazione-page" className="mx-auto max-w-5xl rounded-xl border border-slate-200 bg-white p-6 sm:p-10">
        <Link to="/#prezzi" data-testid="attivazione-back-link" className="inline-flex items-center text-sm text-blue-700 hover:underline"><ArrowLeft className="mr-1 h-4 w-4" />Torna ai pacchetti</Link>
        <h1 className="mt-6 font-display text-3xl font-extrabold tracking-tight text-slate-900 sm:text-4xl">Richiesta di attivazione</h1>
        <p className="mb-8 mt-2 text-sm text-slate-600">Fatturazione elettronica · ciclo attivo/passivo PA, B2B e B2C. I campi con * sono obbligatori.</p>
        {pkg === undefined && <p className="text-sm text-slate-500">Caricamento…</p>}
        {pkg === null && <p data-testid="attivazione-not-found" className="text-sm text-red-600">Pacchetto non trovato. <Link to="/#prezzi" className="underline">Scegli un pacchetto</Link>.</p>}
        {pkg && <AttivazioneForm pkg={pkg} />}
      </article>
    </div>
  );
}
